import { render, staticRenderFns } from "./TabCustomerClass.vue?vue&type=template&id=459d34d3"
import script from "./TabCustomerClass.vue?vue&type=script&lang=js"
export * from "./TabCustomerClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports